export const state = {
    layers: [],
    sources: [],
    layers3D: []
};

export default state;
